module.exports = __webpack_public_path__ + "img/project.de19227b.svg";